import React, { useEffect, useState, useRef  } from "react";
import api from "~/services/api";
import { Label, Input, Select, TextArea } from "~/componentes/CustomForm";

import { store } from "~/store";
import { loadingToggle } from "~/store/modules/loadingModal/actions";
import { renderToString } from "react-dom/server";
import { jsPDF } from 'jspdf';

import SDTemplate from './Template/SDTemplate';
import NunitoSemiBold from '~/utils/Nunito-semiBold.js';

import { Container } from "./styles";
import { Materialize } from "~/styles/materializeGrid";
import ShowConfirmacao from "~/utils/ShowConfirmacao";
import AtividadesList from "./AtividadesList";

function VisualContent({ mountedData }) {
  const [projetos, setProjetos] = useState([]);
  const [clientes, setClientes] = useState([]);

  const dispatch = store.dispatch;
  const [geraPdf, setGeraPdf] = useState(false);
  const pdfRef = useRef(null);

  const handleDownload = async () => {
    dispatch(loadingToggle());

    let htmlElement = <SDTemplate data={mountedData} />;
    let elementAsString = renderToString(htmlElement);

    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: 'p'
    });
    doc.addFileToVFS('Nunito-semibold.ttf', NunitoSemiBold);
    doc.addFont('Nunito-semibold.ttf', 'Nunito', 'normal');
    doc.setFont('Nunito');

    doc.setFontSize(10);
    doc.html(elementAsString, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
        dispatch(loadingToggle());
      },
    });
  };

  useEffect(() => {
    if (geraPdf) {
      handleDownload();
      setGeraPdf(false);
    }
  }, [geraPdf]);

  useEffect(() => {
    setProjetos([ mountedData?.projeto ]);
    setClientes([ mountedData?.projeto?.cliente ]);
  }, [mountedData]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    closeReload && closeReload();
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row no-margin">
          <Label title="Cliente *" className="col s6 m2 l2">
            <Select
              required="true"
              isString
              list={{ list: clientes, value: "id", label: "nomeFantasia" }}
              name="idCliente"
              disabled="true"
              defaultValue={mountedData?.idCliente}
            />
          </Label>
          <Label title="Projeto *" className="col s6 m4 l4">
            <Select
              required="true"
              isString
              list={{ list: projetos, value: "id", label: "titulo" }}
              name="idProjeto"
              disabled="true"
              defaultValue={mountedData?.idProjeto}
            />
          </Label>
          <Label title="Versão *" className="col s6 m2 l2">
            <Input 
              name="versao" 
              required="true" 
              value={mountedData?.versao}
              disabled="true"
            />
          </Label>
          <Label title="Data Prev Inicio *" className="col s12 m2 l2">
            <Input 
              type="date" 
              name="dataPrevInicio" 
              required="true" 
              defaultValue={mountedData?.dataPrevInicio}
              disabled="true"
            />
          </Label>
          <Label title="Data Prev Entrega *" className="col s12 m2 l2">
            <Input 
              type="date" 
              name="dataPrevFinal" 
              required="true" 
              defaultValue={mountedData?.dataPrevFinal}
              disabled="true"
            />
          </Label>
        </div>
        <div className="row no-margin">
          <div className="col s12 m12 l12">
            <AtividadesList defaultData={mountedData?.itens || []} />
          </div>
        </div>
      </Materialize>
      <div className="footer">
        {mountedData && (
          <div className="btn-imp" onClick={() => setGeraPdf(true)}>
            <p>Imprimir</p>
          </div>
        )}
      </div>
    </Container>
  );
}

export default VisualContent;
